export const API_KEY = `${process.env.REACT_APP_ARBITRAGE_API_KEY}`;
//export const API_ENDPOINT_ARBITRAGE = "http://127.0.0.1:5000/internal/data/arbitrage";
export const API_ENDPOINT_ARBITRAGE = "https://crunchtimeodds.com/internal/p/arbitrage";
export const API_ENDPOINT_ARBITRAGE_2 = "https://crunchtimeodds.com/internal/data/arbitrage";
export const VALID_SITES = [
  "betmgm",
  "betrivers",
  "caesars",
  "draftkings",
  "espnbet",
  "fanduel",
  "prophetx",
  "sporttrade (nj)",
  "novig",
  "betonline",
  "overtime (optimism)",
  "polymarket",
  "kalshi",
  "rebet",
  "kutt",
  "fliff",
];
export const VALID_SITES_2 = [
  "betmgm",
  "betrivers",
  "caesars",
  "draftkings",
  "espnbet",
  "fanduel",
  "prophetx",
  "sporttrade (nj)",
  "novig",
  "betonline",
  "overtime (arbitrum)",
  "overtime (optimism)",
  "overtime (base)",
  "prophetx (sandbox)",
  "polymarket",
  "kalshi",
  "rebet",
  "kutt",
  "fliff",
];
export const SPREAD_MARKETS = [
  'point-spread',
  'sets-spread',
  'games-spread',
  'puck-line',
  'run-line',
];